export enum TranscoderModeEnum {
  Libx264 = 1,
  Libx265 = 2,
}

export type TranscoderMode =
  | TranscoderModeEnum.Libx264
  | TranscoderModeEnum.Libx265;
